var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wrapper"},[_c('Loader'),_c('SidebarStyle9'),_c('HeaderStyle9'),_c('div',{staticClass:"content-page px-3 margin-top-mediaQ"},[_c('transition',{attrs:{"name":"router-anim"}},[_c('router-view')],1)],1)],1),_c('FooterStyle')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }